import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgbModal, NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { NoDataFoundComponent } from "../no-data-found/no-data-found.component";

@Component({
  selector: 'app-language',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, NoDataFoundComponent, NgbPagination],
  templateUrl: './language.component.html',
  styleUrl: './language.component.css',
})
export class LanguageComponent implements OnInit {
  isEditMode: boolean = false;
  translationForm: FormGroup;
  currentPage = 1;
  pageSize = 5;
  pageSizes: number[] = [5, 10, 15, 20];

  constructor(private fb: FormBuilder, private modalService: NgbModal) {
    this.translationForm = this.fb.group({
      title: ['', [Validators.required]],
      englishText: ['', [Validators.required]],
      arabicText: ['', [Validators.required]],
      keyword: ['', [Validators.required]],
      textType: ['', [Validators.required]],
      remarks: ['', [Validators.required]],
    });
  }

  data = [
    {
      title: 'New Update',
      description: 'Version 2.0 Released',
      screenNumber: 'Screen 5',
      userType: '1',
      ar_Title: 'تحديث جديد',
      ar_Description: 'الإصدار 2.0 تم إطلاقه',
      dataContent: 'UpdateDetails',
      remarks: 'Release notes attached',
      notificationKey: 'update_v2'
    },
    {
      title: 'Maintenance Notice',
      description: 'Scheduled downtime on Sunday',
      screenNumber: 'Screen 2',
      userType: '2',
      ar_Title: 'إشعار صيانة',
      ar_Description: 'انقطاع مجدول يوم الأحد',
      dataContent: 'MaintenanceInfo',
      remarks: 'Email sent to all users',
      notificationKey: 'maint_notice'
    }
  ];
  

  // ----------------------------- ONINIT ----------------------------- //

  ngOnInit() {}

  // --------------------------- Pagination --------------------------- //

  onPageChange(page: number) {
    this.currentPage = page;
  }

  get pagedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = this.currentPage * this.pageSize;
    return this.data?.slice(start, end);
  }

  // ----------------------------- Create translation post api ----------------------------- //

  openTranslateModal(content: any) {
    this.isEditMode = false;
    this.modalService.open(content, { size: 'lg' });
  }

  openEditModal(content: any) {
    this.modalService.open(content, { size: 'lg' });
  }

  createTranslation() {}

  // ----------------------------- Update translation post api ----------------------------- //

  update() {}

  openDeleteModal(content: any) {

  }

  // ----------------------------- Export to excel ----------------------------- //

  exportToExcel() {}
}
